(function ($, drupalSettings, once) { // eslint-disable-line no-unused-vars
  'use strict';

  // Toggle button behaviour
  //
  Drupal.behaviors.toggleButton = {
    attach: function (context) {
      once('toggleButton', '.js-toggle', context).forEach(Drupal.behaviors.toggleButton.init);
    },
    init: function(el) {
      $(el).on('click.toggleButton', Drupal.behaviors.toggleButton.toggle);
    },
    toggle: function(e) {
      let $button = $(e.currentTarget);
      let $panel  = $button.attr('aria-controls') ? $('#' + $button.attr('aria-controls')) : false;
      let $container = $('body');
      let className = 'toggle-' + $button.attr('aria-controls') + '-on';

      if($panel.length) {
        if($button.attr('aria-pressed') === 'true') {
          $button.attr('aria-pressed', false);
          $panel.attr('aria-hidden', true);
          $container.removeClass(className);
        }
        else {
          $button.attr('aria-pressed', true);
          $panel.attr('aria-hidden', false);
          $container.addClass(className);
        }
      }
    }
  };

  // Global drilldown nav
  //
  Drupal.behaviors.drilldownNav = {
    attach: function(context) {
      once('drilldownNav', '.js-nav-drilldown', context).forEach(Drupal.behaviors.drilldownNav.init);
    },
    init: function(el) {
      let $el       = $(el);
      let $menuItem = $el.find('.js-nav-has-children');
      let $menuBack = $el.find('.js-nav-drillup');
      let $menuLink = $el.find('a');

      // Toggle CSS class on menu items
      $menuItem
      .on('click.drilldownNav touchend.drilldownNav', function(){
        $(this).addClass('is-open').parents('.js-nav-drilldown-parent').eq(0).addClass('is-open');
      });

      $menuLink.on('touchstart.drilldownNav', function(e){
        e.stopPropagation();
      });

      $menuBack.on('click.drilldownNav', function(e){
        e.stopPropagation();
        $(this).parents('.is-open').slice(0,2).removeClass('is-open');
      });
    }
  };

  // Global horizontal nav
  //
  Drupal.behaviors.globalNav = {
    attach: function(context) {
      once('globalNav', '.js-nav-main', context).forEach(Drupal.behaviors.globalNav.init);
    },
    init: function(el) {
      let $el       = $(el);
      let $menuItem = $el.find('.js-nav-has-children');
      let $body     = $('body');

      // Align flyouts that are wider than the navigation to the right
      $menuItem.each(function(){
        let $flyout = $(this).children('div');

        // LTR
        if( Math.ceil($flyout.offset().left + $flyout.outerWidth()) > Math.ceil($el.offset().left + $el.outerWidth()) ) {
          $flyout.addClass('at-end');
        }
        // RTL
        if( $flyout.offset().left < 0 ) {
          $flyout.addClass('at-end');
        }
      });

      // Toggle CSS class on menu items
      $menuItem
      .on('mouseenter.globalNav touchstart.globalNav', function(e){
        e.stopPropagation();
        $(this).addClass('hover');
      })
      .on('mouseleave.globalNav', function(){
        $(this).removeClass('hover');
      });

      // Remove CSS class on touch devices when user touches outside
      $body
      .on('touchstart.globalNav', function(){
        $menuItem.removeClass('hover');
      })
    },
  };

  /**
   * Map behavior.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.toggleMapScrolling = {
    attach: function() {
      $('.map--active').click(function (e) {
        e.preventDefault();
        $(this).hide();
        $('.map--inactive').show();
        $('.map-overlay').hide();
      });
      $('.map--inactive').click(function (e) {
        e.preventDefault();
        $(this).hide();
        $('.map--active').show();
        $('.map-overlay').show();
      });
    }
  };

}(jQuery, drupalSettings, once));
